import { render, staticRenderFns } from "./EDatePickerCalendarioLetivo.vue?vue&type=template&id=4e3e3d97&scoped=true"
import script from "./EDatePickerCalendarioLetivo.vue?vue&type=script&lang=js"
export * from "./EDatePickerCalendarioLetivo.vue?vue&type=script&lang=js"
import style0 from "./EDatePickerCalendarioLetivo.vue?vue&type=style&index=0&id=4e3e3d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e3d97",
  null
  
)

export default component.exports